import React from 'react';
import './App.css';
import HomePage from './pages/HomePage';

const App:React.FC = () => {
  return (
    <HomePage />
  );
}

export default App;
